<template>
  <div class="cash-withdrawal" style="padding-top: 1rem">
    <!--<navTitle title="余额提现"></navTitle>-->
    <navTitle
      :title="
        $router.app._route.query.ti ? $router.app._route.query.ti : 'Withdraw'
      "
      path="/user"
    ></navTitle>

    <div class="isnull" v-if="showTips === 'true'">
      You have not link e-wallet yet, please link and submit withdrawal application again.
      <div class="isnull-btn" @click="$router.push({ path: '/user/myPay' })">
        Link now
      </div>
    </div>

    <div v-if="showTips === 'false'">
      <div class="value-item">
        <div class="T1">withdraw amount</div>
        <!--<div class="flex">-->
          <!--<div class="I1">{{icon_moeny}}</div>-->
          <!--<input type="number" @keyup="getwithdraw_fee" v-model="post.money" />-->
        <!--</div>-->

        <div class="money-switch" style="padding-bottom: 0px">
          <div class="switch-item" :class="switch_index==index?'switch-click':''" v-for="(item,index) in money_switch" v-key="index" @click="switchItem(item,index)">{{icon_moeny}}{{item}}</div>
        </div>

        <!--<div class="min"></div>-->
        <div class="max">
          balance:{{icon_moeny}}{{ now_money }}
          <!--<span class="href" @click="upAll">Withdraw all</span>-->
        </div>
      </div>
      <div class="row-info" v-if="!showError">
        Processing fee:{{icon_moeny}}{{ realFree }}，actual amount :{{icon_moeny}}{{ realPrice }}
      </div>
      <div class="row-error" v-else>
        {{errorMsg}}
      </div>



      <div class="row-wrap">
        <div class="row-T1">Withdraw method</div>
        <div class="row">
          <div class="row-name">E-wallet</div>
        </div>
      </div>
      <div class="row-wrap">
        <div class="row-T1">Withdrawal account</div>
        <div class="row">
          <div class="row-name">Service provider</div>
          <select class="select" v-model="cashId">
            <option value="">Please select withdrawal account</option>
            <option
              v-for="(item, index) in cashList"
              :key="index"
              :value="item.id"
              >{{ item.type }}</option
            >
          </select>
        </div>
        <div class="row">
          <div class="row-name">Account</div>
          <input
            class="input"
            placeholder="Please select service provider"
            v-model="cashUserName"
            disabled="disabled"
          />
        </div>
        <!--<div class="row">-->
        <!--<div class="row-name">手机号</div>-->
        <!--<input class="input" placeholder="请填写卡号" v-model="post.cardnum" />-->
        <!--</div>-->
      </div>
      <div class="submit bg-color-blue" @click="submitted">withdraw </div>
    </div>
  </div>
</template>
<script>
import {
  getBank,
  withdraw_fee,
  getUserInfo,
  user_withdraw
} from "../../../api/user";
import { required } from "@utils/validate";
import { validatorDefaultCatch } from "@utils/dialog";
import navTitle from "@components/navTitle";

export default {
  name: "UserCash",
  components: { navTitle },
  props: {},
  data: function() {
    return {
      icon_moeny:this.global.moeny,

      money_switch:[300,500,1000,2000,5000,10000],
      switch_index:999,
      navList: [
        { name: "Withdraw to bank account", type: "bank", icon: "icon-yinhangqia" },
        { name: "Withdraw to balance", type: "balance", icon: "icon-weixin2" }
        // { name: "支付宝", type: "alipay", icon: "icon-icon34" }
      ],
      userInfo: {
        now_money: 0
      },
      realFree: "0",
      realPrice: "0",
      now_money: "0",
      cashId: "", //选择的运营商
      cashUserName: "", //选择的提现账户
      post: {
        extract_type: "bank",
        alipay_code: "",
        money: ""
      },
      currentTab: 0,
      minPrice: 0,
      banks: [],
      commissionCount: 0,
      showTips: "",
      bomb_submit:false,
      showError:false,
      errorMsg:''
    };
  },
  watch: {
    cashId(n) {
      let list = this.cashList;
      list.forEach(item => {
        if (item.id == n) {
          this.cashUserName = item.account;
        }
      });
    }
  },
  mounted: function() {
    this.getBank();
  },
  methods: {
    switchItem(money,index){
      this.$set(this.post,'money',money)
      this.switch_index = index
      this.getwithdraw_fee()
    },
    getwithdraw_fee() {
      withdraw_fee({ money: this.post.money }).then(res => {
        // console.log('getwithdraw_fee',res)
        this.realPrice = res.data.money;
        this.realFree = res.data.fee;
      }).catch(res=>{
        this.showError = true
        this.errorMsg =res.msg
      })
    },
    swichNav: function(index, item) {
      this.currentTab = index;
      this.post.extract_type = item.type;
    },
    upAll() {
      this.post.money = this.userInfo.now_money;
      withdraw_fee({ money: this.post.money }).then(res => {
        this.realPrice = res.data.money;
        this.realFree = res.data.fee;
      });
    },
    getBank: function() {
      let that = this;
      this.$dialog.loading.open("Loading...");
      getUserInfo().then(res => {
        (this.userInfo = res.data), (this.now_money = res.data.now_money);
      });

      getBank().then(
        res => {
          that.banks = res.data.extractBank;
          that.minPrice = res.data.minPrice;
          that.commissionCount = res.data.commissionCount;
          this.$dialog.loading.close();
          this.cashList = res.data.my_cash;
          let cashList = res.data.my_cash;
          if (cashList.length > 0) {
            this.showTips = "false";
          } else {
            this.showTips = "true";
          }
        },
        function(err) {
          that.$dialog.message(err.msg);
          this.$dialog.loading.close();
        }
      );
    },
    async submitted() {
      let cash_id = this.cashId,
        money = this.post.money,
        that = this;
      if (cash_id == "") {
        return that.$dialog.message("Please select withdrawal account");
      }
      if (!money) {
        return that.$dialog.message("Please enter withdraw amount");
      }
      if (
        parseFloat(money) > parseFloat(that.userInfo.now_money) ||
        parseFloat(that.userInfo.now_money) == 0
      )
        return that.$dialog.message("Insufficient balance");
      if (parseFloat(money) < parseFloat(that.minPrice))
        return that.$dialog.message("Minimum "+that.minPrice+"to withdraw" );

      let save = {
        cash_id: cash_id,
        money: money
      };
      //发起提现

      that.save(save);
    },
    save: function(info) {
      if(this.bomb_submit){
        return
      }

      this.bomb_submit = true
      this.$dialog.loading.open("Loading...");

      user_withdraw(info).then(
        res => {
          this.$dialog.loading.close();
          this.bomb_submit = false
          this.$dialog.message(res.msg);
          this.$router.push({ path: "/user/audit" });
        },
        error => {
          this.$dialog.loading.close();
          this.bomb_submit = false

          this.$dialog.message(error.msg);
        }
      );


    }
  }
};
</script>
<style scoped>
.cash-withdrawal {
  padding: 0 0.3rem;
  box-sizing: border-box;
  /*background: #FAFAFA;*/
}
.row-T1 {
  width: 100%;
  height: 1rem;
  line-height: 1rem;
  padding-left: 0.27rem;
  box-sizing: border-box;
}
.row-info {
  width: 100%;
  height: 0.5rem;
  line-height: 0.5rem;
  padding-left: 0.27rem;
  box-sizing: border-box;
  color: #999;
  margin-top: -10px;
}
.row-error {
  width: 100%;
  box-sizing: border-box;
  color: #ff3c2b;
  margin-top: -10px;

}
.value-item {
  width: 100%;
  /*height: 5rem;*/
  background: #fff;
  padding: 0.27rem 0.27rem 0 0.27rem;
  box-sizing: border-box;
  margin-top: 0.3rem;
  margin-bottom: 0.3rem;
}
.value-item .flex {
  display: flex;
  width: 100%;
  height: 1.2rem;
  border-bottom: 1px solid #eee;
}
.value-item .T1 {
  width: 100%;
  height: 0.6rem;
  line-height: 0.6rem;
}

.value-item .flex .I1 {
  width: 0.4rem;
  font-size: 0.85rem;
  line-height: 1.2rem;
  height: 1.2rem;
}
.value-item .flex input {
  width: 6rem;
  border: none;
  line-height: 1.2rem;
  height: 1.2rem;
  font-size: 0.65rem;
  padding-left: 0.25rem;
  box-sizing: border-box;
}

.value-item .max {
  width: 100%;
  line-height: 1rem;
  height: 1rem;
}

.value-item .min {
  width: 100%;
  line-height: 0.5rem;
  height: 0.5rem;
}

.href {
  color: #0c7cd8;
}
.row-wrap {
  /*margin-bottom: 0.3rem;*/
}
.row {
  width: 100%;
  padding: 0 0.27rem;
  box-sizing: border-box;
  background: #fff;
  height: 0.75rem;
  line-height: 0.75rem;
  display: flex;
  position: relative;
}
.row::after {
  content: "";
  position: absolute;
  width: calc(100% - 0.27rem - 0.27rem);
  bottom: 0px;
  left: 0;
  right: 0;
  margin: 0 auto;
  height: 1px;
  background: #eee;
}
.row .row-name {
  width: 2.5rem;
}
.row .input {
  flex: 1;
  display: block;
  height: 0.75rem;
  line-height: 0.75rem;
  box-sizing: border-box;
  padding-left: 0.15rem;
  border: none;
  background: #fff;
}
.row .select {
  flex: 1;
  display: block;
  height: 0.75rem;
  line-height: 0.75rem;
  box-sizing: border-box;
  padding-left: 0.15rem;
  border: none;
  background: #fff;
}
.submit {
  width: 100%;
  height: 0.92rem;
  background: rgba(0, 195, 249, 1);
  border-radius: 7px;
  color: #fff;
  line-height: 0.92rem;
  text-align: center;
  font-size: 0.35rem;
  margin-top: 1rem;
}


.money-switch{
  width: 100%;
  display: flex;
  flex-wrap: wrap;

  padding: 0.27rem;
  box-sizing: border-box;
  background: #fff;
  border-radius: 3px;
  flex-direction: row;
  align-items:center;
  justify-content: space-around;
}
.money-switch .switch-item {
  width: 30%;
  border: 1px solid #ccc;
  border-radius: 3px;
  margin-bottom: 10px;
  line-height: 50px;
  height: 50px;
  margin-right: 10px;
  color: #333;
  font-size: 0.4rem;
  text-align: center;

}
.money-switch .switch-item:nth-child(3n) {
  margin-right: 0px;
}
.switch-click{
  border: 1px solid #00c3f9!important;
  color: #00c3f9!important;

}
.switch-info{
  margin-bottom: 10px;
  color: #666;
  /*text-align: center;*/
}

</style>
